import { render } from "./ConfirmTeamDeleteDialog.vue?vue&type=template&id=1a50d9a2"
import script from "./ConfirmTeamDeleteDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmTeamDeleteDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__